import axiosInstanceAppStatusGet from "@/service/dashboard/axiosInstanceAppStatusGet";
import axiosInstanceParentGet from "./axiosInstanceParentGet";
import getApplicationForm from "./getApplicationForm";
import getPreviousSchool from "./getPreviousSchool";
import getProfileApi from "./getProfileApi";
import postApplicationForm from "./postApplicationForm";
import postFileUpload from "./postFileUpload";
import putFileUpload from "./putFileUpload";
import postContact from "./postContact";
import getParentProfileApi from "./getParentProfileApi";
import getApplicationLabel from "./getApplicationLabel";
import getSchoolLogos from "./getSchoolLogos";
import axiosInstanceProgressReportGet from "./getProgressReports";
import axiosInstanceDownloadReportGet from "./axiosInstanceDownloadGet";

export const fetchParentData = async (data) => {
  try {
    const requestOptions = {
      method: "GET",
      params: {
        name: data,
      },
    };

    const response = await axiosInstanceParentGet.get("", requestOptions);

    return response;
  } catch (error) {
    console.log(error);
    return error?.response?.status;
  }
};

export const postAplicationFormReq = async (param, formbody) => {
  try {
    const response = await postApplicationForm.post(`${param}`, formbody);

    return response;
  } catch (error) {
    console.log(error);
    return error?.response?.status;
  }
};

export const postAplicationFormReq1 = async (param, formbody) => {
  try {
    const response = await postApplicationForm.post(`${param}`, formbody);

    return response;
  } catch (error) {
    console.log(error);
    return error?.response?.status;
  }
};

export const postAplicationFormReq2 = async (param, formbody) => {
  try {
    const response = await postApplicationForm.post(`${param}`, formbody);

    return response;
  } catch (error) {
    console.log(error);
    return error?.response?.status;
  }
};

export const postAplicationFormReq3 = async (param, formbody) => {
  try {
    const response = await postApplicationForm.post(`${param}`, formbody);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const fetchProfileData = async (userId) => {
  try {
    const requestOptions = {
      method: "GET",
      params: {
        userId: userId,
      },
    };

    const response = await getProfileApi.get(``, requestOptions);

    return response;
  } catch (error) {
    console.log(error);
    return error?.response?.status;
  }
};

export const getAplicationFormProcess = async (type: string, id: string) => {
  try {
    const requestOptions = {
      method: "GET",
    };

    const response = await getApplicationForm.get(
      `${type}/${id}`,
      requestOptions
    );

    return response;
  } catch (error) {
    console.log(error);
    return error?.response?.status;
  }
};

export const getApplicationSchoolProcessData = async (
  type: string,
  id: string
) => {
  try {
    const requestOptions = {
      method: "GET",
    };

    const response = await getPreviousSchool.get(
      `${type}/${id}`,
      requestOptions
    );

    return response;
  } catch (error) {
    console.log(error);
    return error?.response?.status;
  }
};

export const fetchSchoolLogos = async (param, schoolName) => {
  try {
    const response = await postApplicationForm.get(
      `${param}?schoolName=${schoolName}`
    );

    return response;
  } catch (error) {
    console.log(error);
    return error?.response?.status;
  }
};

export const fetchAllSchoolLogos = async (param) => {
  try {
    const requestOptions = {
      method: "GET",
    };

    const response = await getSchoolLogos.get(`${param}`, requestOptions);

    return response;
  } catch (error) {
    console.log(error);
    return error?.response?.status;
  }
};

export const postFileUploadData = async (param, formbody) => {
  try {
    const response = await postFileUpload.post(`${param}`, formbody);

    return response;
  } catch (error) {
    console.log(error);
    return error?.response?.status;
  }
};

export const putFileUploadData = async (param, formbody) => {
  try {
    // const response = await putFileUpload.put(`${param}?sv=${fileUrl}`);

    const response = await putFileUpload.post(`${param}`, formbody);

    return response;
  } catch (error) {
    console.log(error);
    return error?.response?.status;
  }
};

export const getFormReqByiD = async (type, id) => {
  try {
    const requestOptions = {
      method: "GET",
    };

    const response = await postApplicationForm.get(
      `${type}/${id}`,
      requestOptions
    );

    return response;
  } catch (error) {
    console.log(error);
    return error?.response?.status;
  }
};

export const fetchAppStatusData = async (data) => {
  try {
    const response = await axiosInstanceAppStatusGet.get(data);
    return response;
  } catch (error) {
    console.log("error", error);
    return error?.response?.status;
  }
};

export const postContactusForm = async (param, formbody) => {
  try {
    const response = await postContact.post(`${param}`, formbody);

    return response;
  } catch (error) {
    console.log(error);
    return error?.response?.status;
  }
};

export const fetchStudentWithParentInfo = async (id) => {
  try {
    const requestOptions = {
      method: "GET",
    };

    const response = await getParentProfileApi.get(
      `/student/${id}`,
      requestOptions
    );

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const applicationLabelFetchData = async (name: string) => {
  try {
    const requestOptions = {
      method: "GET",
      params: {
        name: name,
      },
    };

    const response = await getApplicationLabel.get("", requestOptions);

    return response;
  } catch (error) {
    console.log(error);
    return error?.response?.status;
  }
};

export const postOfferAcceptance = async (param, formbody) => {
  try {
    const response = await putFileUpload.post(`${param}`, formbody);

    return response;
  } catch (error) {
    console.log(error);
    return error?.response?.status;
  }
};

export const getProgressReportsData = async (data) => {
  try {
    const response = await axiosInstanceProgressReportGet.get(data);
    return response;
  } catch (error) {
    console.log("error", error);
    return error?.response?.status;
  }
};

export const downloadReportData = async (id, sfid) => {
  try {
    const response = await axiosInstanceDownloadReportGet.get(`${id}/${sfid}`);

    return response;
  } catch (error) {
    console.log("error", error);
    return error?.response?.status;
  }
};

export const fetchAcademicStudentLists = async (userId) => {
  try {
    const requestOptions = {
      method: "GET",
    };

    const response = await postApplicationForm.get(`/student-list/${userId}`, requestOptions);

    return response;
  } catch (error) {
    console.log(error);
    return error?.response?.status;
  }
};